/* global fetch */
import axios from 'axios';
import 'fetch-polyfill';
import API from '../../APIconfig';
import {
  CREATE_SESSION,
  IS_LOGGED_IN,
  FETCH_USER,
  GET_USER_DETAILS,
  MIGRATION_STATUS,
  WHO_AM_I,
} from './AuthConstants';

import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError
} from '../async/asyncActions';

// TODO: Remove axios

import {
  goBack,
  historyRedirect,
  isProduction,
} from '../../app/common/util';

import {
  toastr
} from 'react-redux-toastr';

import {
  openModal
} from '../modals/modalActions';

import { getBalance } from '../payments/PaymentActions';
import { listStoredCards } from '../savedCards/CardsActions';

export const whoami = (csrfRequestIdentifier, forwardAction = true) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart('', true, 'whoami'));
      const reqObject = {
        method: API.auth.whoami.method,
        credentials: 'include',
        mode: 'cors',
        headers: new Headers({
          'Content-type': 'application/json',
          csrfRequestIdentifier,
          fcChannel: API.fcChannel,
        }),
      };

      const user = await fetch(API.auth.whoami.url, reqObject).then(response => response.json());

      dispatch({
        type: WHO_AM_I,
        payload: user,
      });

      if (forwardAction) {dispatch(getUserMigrationStatus(user.email, user, csrfRequestIdentifier));}
      else { goBack(user) }
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };
}

export const checkLogIn = (csrfRequestIdentifier) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart('Checking if you are already logged in . . .', true, 'checklogin'));
      const response = await axios({
        url: API.auth.isLoggedIn.url,
        method: API.auth.isLoggedIn.method,
        headers: {
          csrfRequestIdentifier,
          'Content-Type': 'application/json',
          fcChannel: API.fcChannel,
        },
        credentials: API.auth.isLoggedIn.credentials,
        mode: API.auth.isLoggedIn.mode,
      });

      const isLoggedIn = response.data;
      dispatch({
        type: IS_LOGGED_IN,
        payload: isLoggedIn,
      });
      // If user is logged in then get user detail
      if (isLoggedIn.result) {
        const isWithdrawable = isLoggedIn.kycWalletState === 'FULL_KYC';
        dispatch(getBalance(isWithdrawable, csrfRequestIdentifier));
        dispatch(whoami(csrfRequestIdentifier));
      } else {
        // show login form
        if (isProduction()) {
          // If production env, redirect to website/msite for login
          window.location = "https://www.freecharge.in?redirectafterlogin=accounts";
        } else {
          // If not production env, redirect to login page
          historyRedirect('/accounts/login');
        }

        // finish async
        dispatch(asyncActionFinish());
      }
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };
};

/**
 * createSession
 * @description create sessions
 * @async
 */
export const createSession = (actionToDipatch) => {
  return async dispatch => {
    try {
      // async start
      dispatch(asyncActionStart('Connecting to Server . . .', true, 'createsession'));

      // Fetch Session
      const session = await axios({
        url: API.auth.createSession.url,
        method: API.auth.createSession.method,
        credentials: API.auth.createSession.credentials,
        mode: API.auth.createSession.mode,
      });

      // Session action
      dispatch({
        type: CREATE_SESSION,
        payload: session.data
      });

      // Check Login
      dispatch(checkLogIn(session.data.csrfRequestIdentifier));
    } catch (error) {
      console.log(error);
      toastr.error('Failed to create user session. ' + error);
      // async error
      dispatch(asyncActionError());
    }
  };
};


export const fetchUser = user => {
  return {
    type: FETCH_USER,
    payload: user,
  }
}

export const doLoginAction = ({
  username,
  password,
  csrfRequestIdentifier
}) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart('Logging You In . . .', true, 'dologin'));
      const reqObject = {
        method: API.auth.loginUser.method,
        credentials: API.auth.loginUser.credentials,
        mode: API.auth.loginUser.mode,
        body: JSON.stringify({
          email: username,
          password,
          fcChannel: API.fcChannel,
          increaseTokenSession: true,
          platformType: 'WEB',
          publicDevice: false,
          twoFA: true,
        }),
        headers: new Headers({
          'Content-type': 'application/json',
          csrfRequestIdentifier,
          fcChannel: API.fcChannel,
        }),
      };

      const user = await fetch(API.auth.loginUser.url, reqObject).then(response => response.json());

      if (user.errorCode && user.errorMessage) {
        toastr.error('Freecharge account', user.errorMessage || 'Unable to login you in');
      }

      if (user.twoFA) {
        dispatch(openModal('TwoFAModal', {
          heading: 'Verification Process',
          subHeading: 'Please enter otp sent to the registered mobile number',
          ctaText: 'Verify',
          disclaimerHeading: 'Why are we verifying your account?',
          disclaimerContent: 'Security of your account is our top priority. We generally ask users to verify their accounts if we see a login from a new mobile device, browser or location. We also ask users to verify their accounts on periodic basis. Thanks for your support.',
        }));
      } else {
        // goBack();
      }

      if (!user.errorCode) {
        dispatch(fetchUser(user));
        dispatch(getBalance(false, csrfRequestIdentifier));
        dispatch(whoami(csrfRequestIdentifier));
      }
      
      dispatch(asyncActionFinish());
    } catch (error) {
      console.log(error);
      toastr.error('Failed to log you in. ' + error);
      dispatch(asyncActionError());
    }
  };
}

export const getUserMigrationStatus = (email, user, csrfRequestIdentifier) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart('Getting token . . .', true, 'ocstatus'));
      const reqObject = {
        method: API.auth.ocstatus(email).method,
        credentials: API.auth.ocstatus(email).credentials,
        mode: API.auth.ocstatus(email).mode,
        headers: new Headers({
          'Content-type': 'application/json',
          fcChannel: API.fcChannel,
        }),
      };

      const status = await fetch(API.auth.ocstatus(email).url, reqObject).then(response => response.json());

      dispatch({
        type: MIGRATION_STATUS,
        payload: status,
      });

      // Change route
      // goBack(user);

      dispatch(asyncActionFinish());
      dispatch(listStoredCards(csrfRequestIdentifier, status.walletToken));
      dispatch(getUserDetails(email));
    } catch (error) {
      console.log(error);
      toastr.error('Failed to get user migration status. ' + error);
      dispatch(asyncActionError());
    }
  };
}

export const getUserDetails = (email, user) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart('Getting your details . . .', true, 'getuserdetails'));
      const reqObject = {
        method: API.auth.userDetails(email).method,
        credentials: API.auth.userDetails(email).credentials,
        mode: API.auth.userDetails(email).mode,
        headers: new Headers({
          'Content-type': 'application/json',
          fcChannel: API.fcChannel,
        }),
      };

      const profile = await fetch(API.auth.userDetails(email).url, reqObject).then(response => response.json());

      dispatch({
        type: GET_USER_DETAILS,
        payload: profile,
      });

      dispatch(asyncActionFinish());

      // Change route
      goBack(user);
    } catch (error) {
      console.log(error);
      toastr.error('Failed to get user details. ' + error);
      dispatch(asyncActionError());
    }
  };
}